(function() {
  'use strict';

  angular.module('app.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) { //, panelsProvider
    // TODO: consider thinking about a better way to load the fields/configs on routes with a map that are already load information form the web map
    var dashboardState = {
      name: 'admin',
      url: '/admin',
      templateProvider: function($templateCache) {
        return $templateCache.get('pages/admin/map/map.html');
      },
      controller: 'AdminMapViewCtrl',
      controllerAs: 'vm',
      resolve: {
        query: function(Parcels) {
          return Parcels.getActiveQuery();
        },
        user: function(agoSecurity, sessionService) {
          return agoSecurity.initialize(sessionService.getTokenInfo());
        },
        config: function($http, appConfig, user) {
          if (!appConfig.getConfig()) {
            return $http.get('/api/v1/config').then(function(response) {
              appConfig.setConfig(response.data);
              return appConfig.getAdminWebMapData();
            });
          } else {
            if (!appConfig.getConfig().parcelsUrl) {
              return appConfig.getAdminWebMapData();
            } else {
              return appConfig.getConfig();
            }
          }
        }
      },
      title: 'Admin Map'
    };

    var parcelsDashboardState = {
      name: 'dashboard',
      url: '/dashboard',
      templateProvider: function($templateCache) {
        return $templateCache.get('pages/admin/dashboard/dashboard.html');
      },
      controller: 'DashboardCtrl',
      controllerAs: 'vm',
      resolve: {
        query: function(maps) {
          return maps.getQuery();
        },
        user: function(agoSecurity, sessionService) {
          return agoSecurity.initialize(sessionService.getTokenInfo());
        },
        config: function($http, appConfig, user) {
          if (!appConfig.getConfig()) {
            return $http.get('/api/v1/config').then(function(response) {
              appConfig.setConfig(response.data);
              return appConfig.getAdminWebMapData();
            });
          } else {
            if (!appConfig.getConfig().parcelsUrl) {
              return appConfig.getAdminWebMapData();
            } else {
              return appConfig.getConfig();
            }
          }
        },
        fields: function(fieldDomains, config) {
          return fieldDomains.initialize(config);
        }
      },
      title: 'Parcels Dashboard'
    };

    var parcelsDetailsState = {
      name: 'details',
      url: '/details/:id',
      title: 'Parcel Details',
      templateProvider: function($templateCache) {
        return $templateCache.get('pages/admin/dashboard/parcel/details.html');
      },
      controller: 'ParcelController',
      controllerAs: 'vm',
      resolve: {
        user: function(agoSecurity, sessionService) {
          return agoSecurity.initialize(sessionService.getTokenInfo());
        },
        config: function($http, appConfig, user) { //, $rootScope
          if (!appConfig.getConfig()) {
            return $http.get('/api/v1/config').then(function(response) {
              appConfig.setConfig(response.data);
              return appConfig.getAdminWebMapData();
            });
          } else {
            if (!appConfig.getConfig().parcelsUrl) {
              return appConfig.getAdminWebMapData();
            } else {
              return appConfig.getConfig();
            }
          }
        },
        fields: function(fieldDomains, config) {
          return fieldDomains.initialize(config);
        },
        parcel: function(Parcels, $stateParams, config) {
          return Parcels.read($stateParams.id);
        }
      }
    };

    var reportsDashboardState = {
      name: 'reports',
      url: '/reports',
      templateProvider: function($templateCache) {
        return $templateCache.get('pages/admin/dashboard/reports.html');
      },
      controller: 'ReportsCtrl',
      controllerAs: 'vm',
      resolve: {
        user: function(agoSecurity, sessionService) {
          return agoSecurity.initialize(sessionService.getTokenInfo());
        },
        config: function($http, appConfig, user) { //, $rootScope
          if (!appConfig.getConfig()) {
            return $http.get('/api/v1/config').then(function(response) {
              appConfig.setConfig(response.data);
              return appConfig.getAdminWebMapData();
            });
          } else {
            if (!appConfig.getConfig().parcelsUrl) {
              return appConfig.getAdminWebMapData();
            } else {
              return appConfig.getConfig();
            }
          }
        },
        fields: function(fieldDomains, config) {
          return fieldDomains.initialize(config);
        }
      },
      title: 'Reports Dashboard'
    };

    $stateProvider.state(dashboardState);
    $stateProvider.state(parcelsDashboardState);
    $stateProvider.state(parcelsDetailsState);
    $stateProvider.state(reportsDashboardState);

  }

})();